export default __webpack_public_path__ + "static/media/15.d70c1c41.png";